/** Durum rozetinin tonu. Metin backend'den geldiği gibi basılır; ton yalnız rengi seçer. */
export type ServiceStatusTone = 'done' | 'waiting' | 'neutral'

/** Kapanmış kayıt sinyalleri. */
const DONE_KEYWORDS = ['tamam', 'teslim', 'kapa', 'sonuçlan']
/** Bayiden/servisten bir şey beklenen kayıt sinyalleri. Gövde 'bekl' — "bekleniyor" ve "bekliyor"
 *  bu ortak gövdeyi paylaşır (kip eki öncesi ünlü düşmesi); tek kelime her iki çekimi de yakalar. */
const WAITING_KEYWORDS = ['bekl']

/**
 * Serbest metin durumunu ("İade Faturası Bekleniyor", "İşlemde") rozet tonuna eşler.
 * Durum sözlüğü backend'de olduğu için eşleme sabit bir enum yerine anahtar kelimeyle yapılır;
 * tanınmayan durum nötr kalır. Durum METNİ hiçbir koşulda değiştirilmez — burada yalnız renk seçilir.
 * `waiting` kontrolü `done`'dan önce çalışır: "Tamamlandı, iade faturası bekleniyor" gibi bir
 * metinde "…bekleniyor/bekliyor" yüklemi baskındır — kayıt henüz kapanmamıştır.
 */
export function getServiceStatusTone(status?: string | null): ServiceStatusTone {
  const normalized = (status ?? '').toLocaleLowerCase('tr-TR').trim()
  if (!normalized) return 'neutral'
  if (WAITING_KEYWORDS.some(keyword => normalized.includes(keyword))) return 'waiting'
  if (DONE_KEYWORDS.some(keyword => normalized.includes(keyword))) return 'done'
  return 'neutral'
}
